module.exports = __webpack_public_path__ + "static/media/btn_voltar.7c38f7e8.svg";